<template>
    <div class="dashboard">
        <div class="l-2-00-t--all l-mb3">
            <div>
                <h1>配車一覧</h1>
            </div>
            <div>
                <input v-model="params.date" class="l-w4" type="date" @change="fetchingListDeliveryAllocations()">
            </div>
        </div>
        <table>
            <Sort :column="tableSet" :list="listDeliveryAllocations" :option="{ 'key': 'contractor' }" @sort-list="setSortList($event)" />
            <!-- <tr>
                <th>
                    &nbsp;
                </th>
                <th v-for="data in tableSet" :key="data.key" :class="data.class">
                    {{ data.head }}
                </th>
                <th class="is-right">&nbsp;</th>
            </tr> -->
            <tr v-for="(list, index) in sortingListDeliveryAllocations" :class="setClassDisplayOrderStyle(list.delivery_destination_id)" :key="`list${index}`">
                <td v-if="sortFlag < 2">
                    {{ displayOrderNo() }}
                </td>
                <td v-else>
                    &nbsp;
                </td>
                <template v-for="data in tableSet">
                    <template v-if="data.key !== 'checked_residual_water'">
                        <td v-if="data.key === 'lapse_time_1'" :key="`list${index}${data.key}`" :class="[data.class, setClassWarning(list.residual_water_time, list.site_arrival_time)]">
                            {{ calcLapseTime(list.residual_water_time, list.site_arrival_time) }}
                        </td>
                        <td v-else-if="data.key === 'lapse_time_2'" :key="`list${index}${data.key}`" :class="[data.class, setClassWarning(list.site_arrival_time, list.site_departure_time)]">
                            {{ calcLapseTime(list.site_arrival_time, list.site_departure_time) }}
                        </td>
                        <td v-else-if="data.key === 'lapse_time_3'" :key="`list${index}${data.key}`" :class="[data.class, setClassWarning(list.site_departure_time, list.factory_arrival_time)]">
                            {{ calcLapseTime(list.site_departure_time, list.factory_arrival_time) }}
                        <td v-else-if="data.key === 'delivery_allocations_amount'" :key="`list${index}${data.key}`" :class="data.class">
                            {{ list.delivery_allocations_amount_text }}
                        </td>
                        <td v-else :key="`list${index}${data.key}`" :class="data.class">
                            {{ list[data.key] }}
                        </td>
                    </template>
                </template>
                <td class="is-right">
                    <router-link :to="{ name: 'offices_delivery_allocations_update', params: { id: String(list.id) }, query: { source: 'allocations' }}" :class="`${classButtonStyle}primary`" type="button" tag="button">変更</router-link>
                    <button :class="`${classButtonStyle}delete`" type="button" @click="setDeleteId(list.id)">削除</button>
                </td>
            </tr>
        </table>
        <Modal :modal="modal" @action="modalAction($event)" @close="$_modalClose()" />
    </div>
</template>

<script>
    "use strict";

    import Sort from "@/components/Sort.vue";

    import common from "@/mixins/common";
    import sorts from "@/mixins/sort";

    const tableDeliveryAllocations = [
        {
            "class": "is-wrap",
            "head": "施工業者",
            "key": "contractor",
        },
        {
            "class": "is-wrap",
            "head": "現場名",
            "key": "delivery_destination_name",
        },
        {
            "class": "",
            "head": "車両ID",
            "key": "vehicle_id",
        },
        {
            "class": "",
            "head": "ドライバー",
            "key": "driver_name",
        },
        {
            "class": "is-right",
            "head": "納入量（㎥）",
            "key": "delivery_allocations_amount",
        },
        {
            "class": "is-right",
            "head": "工場発時刻", // 元・残水時刻
            "key": "residual_water_time",
        },
        {
            "class": "is-right",
            "head": "",
            "key": "lapse_time_1",
        },
        {
            "class": "is-right",
            "head": "現場着時刻",
            "key": "site_arrival_time",
        },
        {
            "class": "is-right",
            "head": "",
            "key": "lapse_time_2",
        },
        {
            "class": "is-right",
            "head": "現場発時刻",
            "key": "site_departure_time",
        },
        {
            "class": "is-right",
            "head": "",
            "key": "lapse_time_3",
        },
        {
            "class": "is-right",
            "head": "工場着時刻",
            "key": "factory_arrival_time",
        },
    ];

    let displayOrderId = "";
    let displayOrderNo = 0;
    let displayOrderClass = "";

    export default {
        "components": {
            Sort,
        },
        "mixins": [
            common,
            sorts,
        ],
        data() {
            return {
                "classButtonStyle": "button--",
                "deleteItemId": "",
                "listDeliveryAllocations": [],
                "params": {
                    "date": "",
                },
                "sortFlag": 0,
                "sortList": [],
                "tableSet": tableDeliveryAllocations,
                "updateCheck": "",
            };
        },
        "computed": {
            sortingListDeliveryAllocations() {
                // 現場名で昇順
                // 初期表示とソート機能のデータ振り分け
                const list = this.sortFlag > 1 ? this.sortList : this.listDeliveryAllocations;
                displayOrderNo = 0;
                // const key = "delivery_destination_name";
                // return this.$_sorting(list, key);
                return list;
            },
        },
        created() {
            this.setDate();
            this.fetchingListDeliveryAllocations();
        },
        mounted() {
            this.updateCheck = setInterval(() => {
                this.fetchingListDeliveryAllocations();
            }, 30000);
        },
        beforeDestroy() {
            clearInterval(this.updateCheck);
        },
        "methods": {
            displayOrderNo() {
                return displayOrderNo !== 0 ? displayOrderNo : 1;
            },
            setClassDisplayOrderStyle(id) {
                if (displayOrderId !== id && this.sortFlag > 0) {
                    displayOrderId = id;
                    displayOrderNo += 1;
                    if (!displayOrderClass) {
                        displayOrderClass = "cust-display-order";
                    } else {
                        displayOrderClass = "";
                    }
                }
                return displayOrderClass;
            },
            calcLapseTime(time1, time2) {
                // 時間の差分を計算
                let lapseTime = "";
                if (time1 && time2) {
                    const date1 = new Date(`${this.params.date}T${time1}`);
                    const date2 = new Date(`${this.params.date}T${time2}`);
                    const difference = date2.getTime() - date1.getTime();
                    lapseTime = Math.floor( difference / 60000 );
                }
                return lapseTime;
            },
            setClassWarning(time1, time2) {
                // 時間差分が80以上の場合classを追加
                let classWarning = "";
                const lapseTime = this.calcLapseTime(time1, time2);
                if (Number(lapseTime) > 79) {
                    classWarning = "is-text-red";
                }
                return classWarning;
            },
            setDate() {
                // 今日の日付をset
                const today = new Date();
                const year = today.getFullYear();
                const month = ("0" + (today.getMonth() + 1)).slice(-2);
                const date = ("0" + today.getDate()).slice(-2);
                this.params.date = `${year}-${month}-${date}`;
            },
            modalAction(key) {
                if (key === "deleteDeliveryAllocations") {
                    this.handleDelete();
                } else if (key === "deleteDeliveryAllocations--finished") {
                    this.$_modalClose();
                    this.fetchingListDeliveryAllocations();
                }
            },
            fetchingListDeliveryAllocations() {
                displayOrderClass = "reset";
                this.sortFlag = 0;
                this.$_requestCancel("SelectDate");
                // 全納入割当データ取得
                common.$_axios.get(
                    `${common.$_configs.apiUrl}/delivery_allocations`,
                    this.$_requestConfig("SelectDate")
                ).then(response => {
                    // 表示順を0に戻す
                    displayOrderNo = 0;
                    // 納入割当IDで昇順
                    const sortIdList = response.data.sort((a, b) => a.id - b.id);
                    // 納入先IDで昇順
                    this.listDeliveryAllocations = sortIdList.sort((a, b) => a.delivery_destination_id - b.delivery_destination_id);
                    let destinationId = "";
                    let allocationsAmount = 0;
                    // 納入量の表示テキストをset
                    for (let i in this.listDeliveryAllocations) {
                        const deliveryDestinationId = this.listDeliveryAllocations[i].delivery_destination_id;
                        const deliveryAllocationsAmount = this.listDeliveryAllocations[i].delivery_allocations_amount;
                        if (destinationId === deliveryDestinationId) {
                            allocationsAmount = allocationsAmount + Number(deliveryAllocationsAmount);
                            this.listDeliveryAllocations[i].delivery_allocations_amount_text = `${deliveryAllocationsAmount}／${allocationsAmount.toFixed(2)}`;
                        } else {
                            this.listDeliveryAllocations[i].delivery_allocations_amount_text = `${deliveryAllocationsAmount}`;
                            destinationId = deliveryDestinationId;
                            allocationsAmount = Number(deliveryAllocationsAmount);
                        }
                    }
                }).catch(() => {
                    this.$_modalError("fetchingDeliveryAllocationsError");
                });
            },
            setDeleteId(id) {
                // 削除IDをset
                this.deleteItemId = id;
                this.$_modalOpen("deleteDeliveryAllocations");
            },
            handleDelete() {
                // 個別納入割当データ削除
                common.$_axios.delete(
                    `${common.$_configs.apiUrl}/delivery_allocations/${this.deleteItemId}`,
                    this.$_requestConfig()
                ).then(() => {
                    this.$_modalFinished();
                }).catch(() => {
                    this.$_modalError();
                });
            },
            setSortList(data) {
                // 初期表示でソート機能を優先させなための仕組み
                if (data.length > 0 && this.sortFlag >= 1) {
                    this.sortList = data;
                }
                this.sortFlag++;
            },
        },
    };
</script>

<style lang="scss" scoped>
    .is-wrap {
        min-width: 160px;
    }
</style>
